module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_zambia-28962ca7.png";